const RewardedTrxTypes: any = {
  // ACHConvertedCheck: 'ACH Converted Check',
  // ACHCredit: 'ACH Credit',
  // ACHDebit: 'ACH Debit',
  // ACHDirectDeposit: 'ACH Direct Deposit',
  // ATMFeeRefund: 'ATM Fee Refund',
  // ATMWithdrawal: 'ATM Withdrawal',
  // BillPay: 'Bill Pay',
  // Check: 'Check',
  // ForeignATMUsageFee: 'Foreign ATM Usage Fee',
  // ForeignATMUsageFeeRefund: 'Foreign ATM Usage Fee Refund',
  // InterestPaid: 'Interest Paid',
  // InterestReversal: 'Interest Reversal',
  // iTunes: 'iTunes',
  // NSF: 'NSF',
  // NSFRefund: 'NSF Refund',
  POS: 'All POS transactions',
  POS_PIN: 'POS PIN transactions only',
  // POSRefund: 'POS Refund',
  // POSReward: 'POS Reward',
  POS_SIGNATURE: 'POS Signature transactions only',
  // REALTunesRefund: 'REALTunes Refund',
  // ServiceCharge: 'Service Charge'
  CC: 'CC transactions only',
  POS_CC: 'All POS or CC transactions',
  POS_PIN_CC: 'POS PIN or CC transactions',
  POS_SIGNATURE_CC: 'POS Signature or CC transactions',
  KASASA_STREAM_REWARD: 'Video/Audio/Gaming Streaming Purchases',
  KASASA_EATS_REWARD: 'Grocery and Meal Delivery Purchases',
};

export default RewardedTrxTypes;
